var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2 L2,7 L12,12 L22,7 L12,2 Z",
    stroke: "#FF8C42",
    strokeWidth: 2,
    fill: "#FF8C42",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,17 L12,22 L22,17",
    stroke: "#FF8C42",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,12 L12,17 L22,12",
    stroke: "#FF8C42",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.ab68b91adfa042f216e5d29008cfe076.svg";
export { ForwardRef as ReactComponent };